var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 42,
    viewBox: "0 0 63 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5283 28.9754C43.3539 28.9754 48.8871 23.4422 48.8871 16.6166C48.8871 9.79103 43.3539 4.25781 36.5283 4.25781C29.7028 4.25781 24.1696 9.79103 24.1696 16.6166C24.1696 23.4422 29.7028 28.9754 36.5283 28.9754Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5283 22.1123C39.5637 22.1123 42.0244 19.6516 42.0244 16.6162C42.0244 13.5808 39.5637 11.1201 36.5283 11.1201C33.4929 11.1201 31.0322 13.5808 31.0322 16.6162C31.0322 19.6516 33.4929 22.1123 36.5283 22.1123Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.53 31.9705V28.9761",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.53 4.25618V1.26172",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2073 29.9147L42.7076 27.3169",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3523 5.91081L28.8527 3.31787",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8236 24.2936L47.2307 22.7939",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8245 10.4386L23.2316 8.93896",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8843 16.6162H48.885",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1699 16.6162H21.1754",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8236 8.93896L47.2307 10.4386",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8245 22.7939L23.2316 24.2936",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2073 3.31787L42.7076 5.91565",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3523 27.3218L28.8527 29.9147",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1047 41.1958V38.9463",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1047 26.9301V24.6807",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9439 38.7771L58.3523 37.1855",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8576 28.6907L48.266 27.0991",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3626 32.938H60.1132",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0966 32.938H45.8472",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1133 32.9379C60.1133 34.5973 59.4409 36.0969 58.3524 37.1853C57.2687 38.2738 55.7643 38.9463 54.105 38.9463C52.4457 38.9463 50.9412 38.2738 49.8576 37.1853C48.7692 36.0969 48.0967 34.5973 48.0967 32.9379C48.0967 31.2787 48.7692 29.7791 49.8576 28.6906C50.9412 27.6022 52.4457 26.9297 54.105 26.9297C55.7643 26.9297 57.2687 27.6022 58.3524 28.6906C59.4409 29.7791 60.1133 31.2787 60.1133 32.9379Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9439 27.0991L58.3523 28.6907",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8576 37.1855L48.266 38.7771",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8035 32.9707L53.9466 32.6987",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1706 28.4614L21.5454 28.7366",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62522 30.6187L1 30.8938",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9175 20.627L18.2552 22.679",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91531 36.6787L5.25305 38.7307",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6429 20.7162L11.3678 18.0933",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8005 41.2616L13.5254 38.6387",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5455 28.7362C21.3254 26.6246 20.3762 24.733 18.9546 23.3092C18.7323 23.0868 18.5008 22.8759 18.2554 22.6787C16.7101 21.42 14.7337 20.668 12.5854 20.668C12.2667 20.668 11.9527 20.684 11.6431 20.7161C9.5315 20.9362 7.63302 21.8854 6.21617 23.3092C5.99372 23.5316 5.78281 23.7655 5.58566 24.0085C4.32924 25.5584 3.57715 27.5302 3.57715 29.6785C3.57715 29.9972 3.59315 30.3113 3.62528 30.6186C3.84538 32.7302 4.79238 34.6217 6.21617 36.0455C6.4385 36.2679 6.67013 36.4788 6.91542 36.6783C8.46079 37.9347 10.4371 38.6868 12.5854 38.6868C12.9018 38.6868 13.2159 38.6707 13.5255 38.6386C15.6393 38.4185 17.5355 37.4693 18.9546 36.0455C19.1771 35.8231 19.388 35.5892 19.5851 35.3462C20.8417 33.7986 21.5936 31.8268 21.5936 29.6785C21.5936 29.3598 21.5776 29.0457 21.5455 28.7362Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58547 24.0089L3.53345 22.3467",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6371 37.0084L19.5851 35.3462",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9053 29.3289C15.8237 28.5465 15.472 27.8456 14.9452 27.318C14.8629 27.2356 14.7771 27.1575 14.6862 27.0844C14.1136 26.618 13.3813 26.3394 12.5853 26.3394C12.4672 26.3394 12.3508 26.3453 12.2361 26.3572C11.4537 26.4388 10.7503 26.7905 10.2253 27.318C10.1429 27.4004 10.0647 27.4871 9.99165 27.5771C9.5261 28.1514 9.24744 28.882 9.24744 29.678C9.24744 29.7961 9.25337 29.9125 9.26527 30.0263C9.34683 30.8088 9.69772 31.5096 10.2253 32.0372C10.3077 32.1196 10.3935 32.1977 10.4844 32.2717C11.057 32.7372 11.7892 33.0159 12.5853 33.0159C12.7025 33.0159 12.8189 33.0099 12.9336 32.998C13.7168 32.9165 14.4194 32.5647 14.9452 32.0372C15.0277 31.9548 15.1058 31.8681 15.1789 31.7781C15.6445 31.2046 15.9231 30.474 15.9231 29.678C15.9231 29.56 15.9172 29.4436 15.9053 29.3289Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitImage);
export default __webpack_public_path__ + "static/media/benefit-image.274589173af89da7cf27a1e01cf0250a.svg";
export { ForwardRef as ReactComponent };